// src/components/layouts/app/header/desktop/BottomBar.tsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, Tag, Headphones } from 'lucide-react';
import { MegaMenu } from './MegaMenu';
import { SectorDropdown } from './SectorDropdown';
import { SearchBarDesktop } from './SearchBarDesktop';

interface BottomBarProps {
  onMegaMenuToggle: (isOpen: boolean) => void;
  isMegaMenuOpen: boolean;
}

const rightNavItems = [
  { label: 'Boutique', path: '/boutique', icon: Tag },
  { label: 'Offres', path: '/offres', icon: Tag, badge: '🔥' },
  { label: 'Support', path: '/support', icon: Headphones },
];

export const BottomBar: React.FC<BottomBarProps> = ({ onMegaMenuToggle, isMegaMenuOpen }) => {
  const location = useLocation();
  const isCategoriesActive = location.pathname === '/categories';

  const handleSearch = (query: string) => {
    console.log('Recherche :', query);
    // Ici, redirection vers page de résultats ou mise à jour du state global
  };

  return (
    <div className="border-t border-gray-300 bg-white shadow-sm">
      <div className="container mx-auto px-0">
        <nav className="flex items-center justify-between h-12">
          {/* Groupe gauche */}
          <div className="flex items-center gap-4 h-full">
            {/* Toutes les catégories */}
            <Link
              to="/categories"
              onMouseEnter={() => onMegaMenuToggle(true)}
              onMouseLeave={() => onMegaMenuToggle(false)}
              className={`
                relative px-4 py-2 text-sm font-medium transition-all duration-200
                flex items-center gap-1.5 rounded-md
                ${isCategoriesActive 
                  ? 'text-primary' 
                  : 'text-black hover:text-gray-900 hover:bg-gray-100'
                }
              `}
            >
              Toutes les catégories
              <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isMegaMenuOpen ? 'rotate-180' : ''}`} />
              {isCategoriesActive && (
                <span className="absolute bottom-0 left-4 right-4 h-0.5 bg-primary rounded-full" />
              )}
            </Link>

            {/* Barre de recherche (composant extrait) */}
            <SearchBarDesktop onSearch={handleSearch} />
          </div>

          {/* Groupe droite */}
          <div className="flex items-center gap-1 h-full">
            <SectorDropdown />
            {rightNavItems.map((item) => {
              const isActive = location.pathname === item.path;
              const Icon = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`
                    relative px-4 py-2 text-sm font-medium transition-all duration-200
                    flex items-center gap-1.5 rounded-md
                    ${isActive 
                      ? 'text-primary' 
                      : 'text-black hover:text-gray-900 hover:bg-gray-100'
                    }
                  `}
                >
                  <Icon className="w-4 h-4" />
                  {item.label}
                  {item.badge && <span className="text-xs ml-1">{item.badge}</span>}
                  {isActive && (
                    <span className="absolute bottom-0 left-4 right-4 h-0.5 bg-primary rounded-full" />
                  )}
                </Link>
              );
            })}
          </div>
        </nav>
      </div>

      {/* Mega Menu */}
      <div
        className={`
          absolute left-0 w-full bg-white shadow-xl border-t border-gray-200 z-30
          transition-all duration-300 ease-out origin-top
          ${isMegaMenuOpen ? 'opacity-100 scale-y-100 visible' : 'opacity-0 scale-y-0 invisible'}
        `}
        onMouseEnter={() => onMegaMenuToggle(true)}
        onMouseLeave={() => onMegaMenuToggle(false)}
      >
        <div className="container mx-auto px-4 py-6">
          <MegaMenu />
        </div>
      </div>
    </div>
  );
};